/**
 * Plain string mirrors of the order "busy/closed settings" action types.
 *
 * DeliveryZoneActions.js (core - backs the `zone` reducer in coreReducerMap)
 * needs to dispatch these after a `../../config/config` call, but importing them
 * from OrderActions.js pulled that entire 800+ line module - and its own
 * config.js/utils.js API slice for the Orders domain - into the eager bundle,
 * even though OrderActions.js is otherwise only used behind lazy order pages.
 *
 * Keep in sync with the canonical `export const SET_*` declarations in
 * OrderActions.js - these are plain redux action-type strings, not expected to
 * change.
 */
export const SET_BUSY_SETTINGS = 'SET_BUSY_SETTINGS'
export const SET_BUSY_SETTINGS_ALL = 'SET_BUSY_SETTINGS_ALL'
export const SET_CLOSED_SETTINGS = 'SET_CLOSED_SETTINGS'
export const SET_CLOSED_SETTINGS_ALL = 'SET_CLOSED_SETTINGS_ALL'
